import { render, staticRenderFns } from "./CreateFolder.vue?vue&type=template&id=249e8bfa&scoped=true"
import script from "./CreateFolder.vue?vue&type=script&lang=js"
export * from "./CreateFolder.vue?vue&type=script&lang=js"
import style0 from "./CreateFolder.vue?vue&type=style&index=0&id=249e8bfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249e8bfa",
  null
  
)

export default component.exports